export const countries = {
  gp: {
    description:
      "A ilha borboleta que oferece rica cultura crioula e praias paradisíacas no vulcão Soufrière.",
    landmarks: ["Vulcão La Soufrière", "Praia Grande Anse", "Quedas de Carbet"],
    gastronomy: "Bolinhos de bacalhau, colombo de frango, tourment d'amour.",
  },
  mq: {
    description:
      "A cativante Ilha das Flores, conhecida pelo Monte Pelée e pelo rum agrícola especial.",
    landmarks: ["Monte Pelée", "Jardim de Balata", "Rochedo do Diamante"],
    gastronomy: "Frango fumado, chouriço crioulo, blanc-manger.",
  },
  gf: {
    description:
      "A imensa porta de acesso à Europa para o espaço com reservas na rica floresta amazônica.",
    landmarks: ["Centro Espacial", "Ilhas da Salvação", "Pântanos de Kaw"],
    gastronomy: "Caldo de awara, fricassé de caça, frango assado.",
  },
  re: {
    description:
      "Uma ilha vulcânica cheia de lagoas exóticas do impressionante Oceano Índico.",
    landmarks: ["Piton de la Fournaise", "Circo de Mafate", "Piton des Neiges"],
    gastronomy: "Rougail de salsicha, caril de frango, chamuças.",
  },
  yt: {
    description:
      "A ilha perfumada cercada por uma grandiosa lagoa com tartarugas e barreiras de coral.",
    landmarks: ["Lagoa de Mayotte", "Monte Choungui", "Praia de N'Gouja"],
    gastronomy: "Espetadas de zebu, mataba, arroz pilaf.",
  },
  pf: {
    description:
      "Um santuário espetacular no Oceano Pacífico, cravado com bangalôs maravilhosos sobre as águas.",
    landmarks: ["Lagoa de Bora Bora", "Monte Otemanu", "Baía de Cook"],
    gastronomy: "Peixe cru de leite de coco, fafaru, poe.",
  },
  nc: {
    description:
      "Terra de vibrantes encantos culturais e naturais com a maior lagoa fechada do vasto mundo.",
    landmarks: ["Farol Amédée", "Coração de Voh", "Baía de Oro"],
    gastronomy: "Bougna tradicional, ceviche de camarão azul.",
  },
  ic: {
    description:
      "Arquipélago espanhol incrível de eternas primaveras e rochedos selvagens impressionantes.",
    landmarks: ["Parque Nacional Teide", "Dunas de Maspalomas", "Timanfaya"],
    gastronomy: "Papas arrugadas, molho mojo mágico, polvo.",
  },
  ptm: {
    description:
      "A imensa ilha da lenda europeia encravada com fantásticas trilhas naturais e o melhor vinho.",
    landmarks: ["Pico do Arieiro", "Pedreira Cabo Girão", "Trilhos Levadas"],
    gastronomy: "Bolo do caco, espetadas tradicionais, peixe-espada preto.",
  },
  pta: {
    description:
      "Um verdadeiro oásis selvagem de crateras vulcânicas intocadas que se unificam na paz celestial natural.",
    landmarks: [
      "Lagoa das Sete Cidades",
      "Montanha do Pico",
      "Termas das Furnas",
    ],
    gastronomy:
      "Cozido das Furnas vulcânicas maravilhosas, queijos divinos São Jorge.",
  },
  aw: {
    description:
      "Fantásticos cenários de areias brancas perfeitos do Caribe batidos pelos maravilhosos ventos dos deuses.",
    landmarks: ["Parque Nacional Arikok", "Eagle Beach", "Farol Califórnia"],
    gastronomy: "Keshi Yena mágico, rissóis deliciosos pastechi.",
  },
  cw: {
    description:
      "Excelente arquitetura mágica num mar cristalino perfeito ao incrível estilo autêntico holandês.",
    landmarks: [
      "Ponte Queen Emma",
      "Santuário Playa Porto Mari",
      "Parque Nacional Christoffel",
    ],
    gastronomy: "Doce Arepa di Pampuna, incrível guisado Karni stoba.",
  },
  sx: {
    description:
      "Magia caribenha esplêndida de vistas estonteantes por baixo dos impressionantes aviões grandiosos.",
    landmarks: [
      "Paraíso Maho Beach",
      "Montanha Pic Paradis",
      "Praia Orient Bay",
    ],
    gastronomy: "Ribs churrasco dos deuses maravilhosos espetaculares.",
  },
  bm: {
    description:
      "A lendária aura dos arquipélagos com areia fina pintada de adorável cor-de-rosa estonteante.",
    landmarks: [
      "Ilha Horseshoe Bay Beach",
      "Cavernas Crystal maravilhosas",
      "Monumental Farol Gibbs Hill",
    ],
    gastronomy: "Esplêndida Chowder gloriosa incrível fantástica Bermuda Fish.",
  },
  ky: {
    description:
      "As mais lindas joias raras escondidas subaquaticas, bailando com impressionantes arraias no cristal celestial.",
    landmarks: [
      "Templo Stingray City maravilhoso",
      "Estonteante Seven Mile Beach incrível",
      "Jardim Mágico Ecelestial Botanic Park",
    ],
    gastronomy: "Sabores gloriosos crioulos divinais Caimão.",
  },

  de: {
    description:
      "A Alemanha combina a modernidade urbana com o romance dos seus castelos e da Floresta Negra. Conhecida por seu dinamismo e rica história.",
    gastronomy: "Salsicha, pretzel, chucrute, cerveja.",
    landmarks: [
      "Portão de Brandemburgo, Berlim",
      "Castelo de Neuschwanstein",
      "Catedral de Colônia",
      "Marienplatz, Munique",
    ],
  },
  be: {
    description:
      "No coração da Europa, a Bélgica é mundialmente conhecida pelas suas encantadoras cidades medievais, pela diplomacia europeia, pelo seu chocolate e cerveja.",
    gastronomy:
      "Waffles, batatas fritas, mexilhões, bombons, cervejas trapistas.",
    landmarks: [
      "Grande Praça de Bruxelas",
      "Campanário de Bruges",
      "Átomo",
      "Castelo de Gravensteen",
    ],
  },
  ch: {
    description:
      "A Suíça é um paraíso alpino que oferece lagos de um azul profundo, fortalezas medievais e montanhas impressionantes, perfeitas tanto para os amantes da natureza quanto do conforto.",
    gastronomy: "Fondue de queijo, raclette, chocolate suíço, rösti.",
    landmarks: [
      "Matterhorn",
      "Lago Genebra",
      "Castelo de Chillon",
      "Jungfraujoch",
    ],
  },
  hr: {
    description:
      "A Croácia oferece mais de mil ilhas ao longo do Mar Adriático, repletas de joias arquitetônicas romanas e exuberantes parques nacionais.",
    gastronomy: "Ćevapi, salada de polvo, peka, queijos da ilha Pag.",
    landmarks: [
      "Muralhas de Dubrovnik",
      "Parque Nacional dos Lagos Plitvice",
      "Palácio de Diocleciano",
    ],
  },
  bg: {
    description:
      "A Bulgária é um mosaico dos Balcãs que combina costas douradas do Mar Negro, terrenos montanhosos e uma incrível herança trácia.",
    gastronomy: "Banitsa, salada Shopska, tarator, moussaka búlgara.",
    landmarks: [
      "Mosteiro de Rila",
      "Catedral de Alexandre Nevsky",
      "Praia ensolarada",
    ],
  },
  cy: {
    description:
      "Chipre é uma lendária ilha mediterrânica, berço de Afrodite, que combina praias imaculadas com impressionantes ruínas antigas.",
    gastronomy: "Halloumi, souvla, sheftalia, moussaka.",
    landmarks: [
      "Parque Arqueológico de Paphos",
      "Rocha de Afrodite",
      "Montanhas Troodos",
    ],
  },
  cz: {
    description:
      "A República Tcheca fascina com suas cidades de cem pináculos, cervejarias centenárias e castelos de contos de fadas no coração da Europa Central.",
    gastronomy: "Goulash, Trdelník, Vepřo knedlo zelo, Pilsner.",
    landmarks: [
      "Ponte Carlos, Praga",
      "Castelo de Praga",
      "Ossário de Sedlec",
      "Karlovy varia",
    ],
  },
  ee: {
    description:
      "A Estónia é uma nação pioneira digital que abriga vastas florestas primitivas e uma capital medieval intacta voltada para o Báltico.",
    gastronomy:
      "Verivorst (chouriço), pão preto, espadilha, cerveja artesanal.",
    landmarks: [
      "Cidade Velha de Tallinn",
      "Parque Nacional Lahemaa",
      "Castelo Hermann",
    ],
  },
  hu: {
    description:
      "A Hungria é lindamente cortada pelo Danúbio, repleta de espetaculares banhos termais, vinhedos históricos e o majestoso parlamento.",
    gastronomy: "Goulash, Lángos, Paprikash de Frango, Vinho Tokaji.",
    landmarks: [
      "Parlamento de Budapeste",
      "Banho Termal Széchenyi",
      "Castelo de Buda",
      "Lago Balaton",
    ],
  },
  fi: {
    description:
      "A Finlândia, o país dos mil lagos, é famosa pela sua natureza selvagem cintilante, pela aurora boreal na Lapónia e pela sua vital cultura de sauna.",
    gastronomy:
      "Salmão fumado, carne de rena, pão de centeio, pastéis da Carélia.",
    landmarks: [
      "Suomenlinna",
      "Aldeia do Papai Noel",
      "Parque Nacional Nuuksio",
    ],
  },
  ie: {
    description:
      "A Irlanda, a Ilha Esmeralda, é definida por seus penhascos varridos pelo vento, música celta calorosa e cultura de pub acolhedora.",
    gastronomy: "Ensopado irlandês, Guinness, pão refrigerante, colcannon.",
    landmarks: [
      "Penhascos de Moher",
      "Armazém Guinness",
      "Anel de Kerry",
      "Colégio Trindade",
    ],
  },
  lt: {
    description:
      "A Lituânia é a joia mais meridional do Báltico, rica em lagos glaciais, florestas densas e testemunhos comoventes de seu passado tumultuado.",
    gastronomy:
      "Cepelinai (bolinhos de batata), sopa fria de borscht (šaltibarščiai).",
    landmarks: [
      "Castelo da Ilha Trakai",
      "Colina das Cruzes",
      "Cidade Velha de Vilnius",
    ],
  },
  lu: {
    description:
      "Luxemburgo é um próspero microestado grão-ducal, cujos vales estão repletos de castelos medievais e a capital é uma cidadela espetacular.",
    gastronomy: "Judd mat Gaardebounen, Gromperekichelcher, vinhos Mosela.",
    landmarks: [
      "Caminho da Corniche",
      "Casamatas de Bock",
      "Castelo de Vianden",
    ],
  },
  lv: {
    description:
      "A Letônia encanta com sua movimentada capital repleta de arquitetura Art Nouveau e quilômetros de praias imaculadas na costa do Báltico.",
    gastronomy:
      "Rupjmaize (pão de centeio escuro), ervilhas cinzentas com bacon, espadilha.",
    landmarks: [
      "Cidade Velha de Riga",
      "Casa dos Pontos Negros",
      "Parque Nacional Gauja",
    ],
  },
  pl: {
    description:
      "A Polónia é o pilar cultural da Europa Oriental, dotada de imponentes cidades restauradas, do trágico memorial de Auschwitz e das montanhas Tatra.",
    gastronomy: "Pierogi, bigos, kielbasa, vodka polonesa.",
    landmarks: [
      "Praça do Mercado de Cracóvia",
      "Mina de sal de Wieliczka",
      "Auschwitz-Birkenau",
      "Castelo Wawel",
    ],
  },
  mt: {
    description:
      "Malta combina perfeitamente o calor do sol mediterrâneo e 7.000 anos de história naval, fortalezas templárias e lagoas azul-turquesa.",
    gastronomy: "Pastizzi, ensopado de coelho (Stuffat tal-fenek), ftira.",
    landmarks: [
      "Co-Catedral de São João",
      "Cidade de Medina",
      "Lagoa Azul (Comino)",
    ],
  },
  sk: {
    description:
      "Menos conhecida, a Eslováquia é um tesouro montanhoso com o maior número de castelos per capita do mundo, dentro dos Altos Tatras.",
    gastronomy: "Bryndzové halušky (nhoque de queijo de ovelha), Kofola.",
    landmarks: ["Castelo de Bratislava", "Altos Tatras", "Castelo de Spiš"],
  },
  si: {
    description:
      "A Eslovênia é um pequeno paraíso ecológico que abriga o mítico Lago Bled, colossais cavernas cársticas e uma capital excepcionalmente verde.",
    gastronomy: "Kranjska klobasa, potica (rolo de nozes), štrukli.",
    landmarks: [
      "Lago Bled",
      "Caverna de Postojna",
      "Castelo de Liubliana",
      "Parque Nacional Triglav",
    ],
  },
  se: {
    description:
      "A Suécia incorpora o estilo escandinavo, espalhado por magníficos arquipélagos, luzes do norte e uma rica tradição de design elegante.",
    gastronomy:
      "Almôndegas (Köttbullar), fika, salmão gravlax, arenque surströmming.",
    landmarks: [
      "Museu Vasa",
      "Cidade de Visby",
      "Gamla Stan",
      "Icehotel Jukkasjärvi",
    ],
  },
  ro: {
    description:
      "Dominada pela lenda de Drácula, a Romênia abriga as suntuosas montanhas dos Cárpatos, o majestoso Delta do Danúbio e as vibrantes cidades da Transilvânia.",
    gastronomy: "Mici, sarmale, mămăligă, tuică.",
    landmarks: [
      "Castelo de Bran",
      "Castelo de Peleș",
      "Delta do Danúbio",
      "Palácio do Parlamento",
    ],
  },
  no: {
    description:
      "A Noruega oferece um dos cenários geológicos mais bonitos do mundo: os seus majestosos fiordes abissais esculpindo o mar rodeados por montanhas íngremes.",
    gastronomy: "Salmão, rakfisk, queijo marrom (Brunost), carne de alce.",
    landmarks: [
      "Fiorde de Geiranger",
      "Cabo Norte",
      "Ilhas Lofoten",
      "Bryggen",
    ],
  },
  is: {
    description:
      "A Islândia, a terra do fogo e do gelo, impressiona com seus gêiseres, geleiras titânicas, vulcões ativos e fontes termais leitosas.",
    gastronomy: "Hákarl (tubarão fermentado), Skyr, cordeiro islandês.",
    landmarks: [
      "Lagoa Azul",
      "Círculo Dourado",
      "Cachoeira Gullfoss",
      "Praia de areia preta de Reynisfjara",
    ],
  },
  ad: {
    description:
      "Situado no alto dos Pirenéus, este pequeno principado é um verdadeiro santuário para os amantes do esqui e da natureza selvagem.",
    gastronomy: "Trinxat, escudella, charcutaria de montanha.",
    landmarks: ["Vale Madriu-Perafita-Claror", "Caldeia", "Grandvalira"],
  },
  al: {
    description:
      "Anteriormente hermética, a Albânia é a joia secreta do Mediterrâneo repleta de águas azuis cristalinas, Alpes espetaculares e ruínas greco-romanas.",
    gastronomy: "Byrek, fëgesë, frutos do mar, baklava.",
    landmarks: ["Riviera Albanesa", "Berat", "Parque Nacional Butrint"],
  },
  at: {
    description:
      "Um país alpino por excelência, a Áustria brilha com a sua música clássica incomparável, palácios imperiais e paisagens alpinas de tirar o fôlego.",
    gastronomy: "Wiener Schnitzel, Apfelstrudel, Sachertorte, Tafelspitz.",
    landmarks: ["Palácio de Schönbrunn", "Hofburgo", "Alpes Kitzbühel"],
  },
  mc: {
    description:
      "Mônaco é o epítome do glamour nas margens do Mediterrâneo, com iates luxuosos, seu cassino mundialmente famoso e o lendário Grande Prêmio de Fórmula 1.",
    gastronomy: "Barbajuan, fougasse monegasco, stocafi.",
    landmarks: [
      "Cassino de Monte Carlo",
      "A Rocha de Mônaco",
      "Palácio do Príncipe",
      "Porto Hércules",
    ],
  },
  by: {
    description:
      "A Bielorrússia surpreende com a sua natureza preservada, florestas densas e imaculadas (como Bialowieza), lar de bisões, e castelos medievais com um passado rico.",
    gastronomy: "Draniki (panquecas de batata), machanka, kolduny.",
    landmarks: ["Castelo Mir", "Palácio Nesvizh", "Fortaleza de Brest"],
  },
  ba: {
    description:
      "Uma encruzilhada de culturas no coração dos Balcãs, onde o Oriente encontra o Ocidente. Você vai se apaixonar pelos rios esmeralda, pelas montanhas escarpadas e pela famosa Ponte Velha de Mostar.",
    gastronomy: "Ćevapi, burek, baklava, café bósnio.",
    landmarks: [
      "Stari Most (Ponte Velha)",
      "Baščaršija (Sarajevo)",
      "Cachoeiras Kravica",
    ],
  },
  az: {
    description:
      "O Azerbaijão, a “Terra do Fogo”, é uma mistura fascinante de património histórico antigo e infra-estruturas ultramodernas reluzentes nas margens do Mar Cáspio.",
    gastronomy: "Plov, dolma, piti, qutab, baklava.",
    landmarks: [
      "Torres de Chamas (Baku)",
      "Cidade Velha (Icherisheher)",
      "Vulcões de lama de Gobustan",
    ],
  },
  am: {
    description:
      "A Arménia, uma das nações cristãs mais antigas do mundo, oferece paisagens montanhosas espectaculares e majestosos mosteiros de pedra situados à beira de desfiladeiros profundos.",
    gastronomy: "Khorovats (churrasco armênio), dolma, lavash, lahmajoun.",
    landmarks: [
      "Mosteiro de Khor Virap",
      "Templo de Garni",
      "Mosteiro Geghard",
    ],
  },
  xk: {
    description:
      "Uma jovem nação balcânica, rica em história e soberbas paisagens montanhosas, o Kosovo destaca-se pelas jóias históricas otomanas bem preservadas e por uma população muito acolhedora.",
    gastronomy: "Flija, burek, qebapa, queijo Šar.",
    landmarks: [
      "Mosteiro Visoki Dečani",
      "Velho Prizren",
      "Desfiladeiro Rugova",
    ],
  },
  ge: {
    description:
      "A Geórgia oferece uma natureza grandiosa nas montanhas do Cáucaso, uma arquitetura antiga fascinante e a reputação de ser a região vinícola mais antiga do mundo.",
    gastronomy: "Khachapuri, khinkali (bolinhos), churchkhela.",
    landmarks: [
      "Igreja da Trindade Gergeti",
      "Centro Histórico de Tbilissi",
      "Vardzia (Cidade Caverna)",
    ],
  },
  md: {
    description:
      "A Moldávia, o tesouro escondido da Europa Oriental, atrai inevitavelmente os entusiastas do enoturismo com as suas enormes caves subterrâneas e mosteiros ancestrais escavados na rocha.",
    gastronomy: "Mămăligă (polenta), plăcinte (pastelaria recheada), sarmale.",
    landmarks: [
      "Orheiul Vechi (Mosteiro da Caverna)",
      "Vinícolas Cricóva",
      "Caves Mileștii Mici",
    ],
  },
  li: {
    description:
      "Uma das menores nações do mundo, o Liechtenstein estende-se entre a Suíça e a Áustria ao longo do vale do Reno, dominado pelo seu belo castelo principesco e pelos picos alpinos.",
    gastronomy: "Käsknöpfle (macarrão com queijo), Ribel.",
    landmarks: [
      "Castelo de Vaduz",
      "Museu de Belas Artes (Kunstmuseum)",
      "Estação de esqui de Malbun",
    ],
  },
  me: {
    description:
      "Apesar do seu pequeno tamanho, Montenegro esconde algumas das mais belas paisagens do Mar Adriático. A Baía de Kotor encontra espetaculares montanhas escuras (as 'montanhas negras').",
    gastronomy:
      "Brav u Mlijeku (cordeiro com leite), cevapi, presunto Njeguši defumado.",
    landmarks: ["Baía de Kotor", "Parque Nacional Durmitor", "Sveti Stefan"],
  },
  fr: {
    description:
      "A França é o principal destino turístico do mundo, conhecida pelo seu património excepcional, paisagens diversas que vão desde a Riviera Francesa aos picos alpinos e uma art de vivre incomparável.",
    gastronomy: "Baguete, queijos, vinho, croissants, bife bourguignon.",
    landmarks: [
      "Torre Eiffel, Paris",
      "Monte Saint-Michel",
      "Castelos do Vale do Loire",
      "Riviera Francesa",
    ],
    overseas: [
      "Guadalupe",
      "Martinica",
      "Guiana Francesa",
      "Reunião",
      "Maiote",
      "Polinésia Francesa",
      "Nova Caledônia",
    ],
  },
  it: {
    description:
      "A Itália é um museu ao ar livre. Entre ruínas romanas, o Renascimento florentino, canais venezianos e um litoral pitoresco, o país oferece uma viagem inesquecível.",
    gastronomy: "Massa, pizza, sorvete, café expresso, tiramisu.",
    landmarks: [
      "Coliseu, Roma",
      "Torre Inclinada de Pisa",
      "Catedral de Florença",
      "Grande Canal, Veneza",
    ],
    overseas: ["Sardenha"],
  },
  gb: {
    description:
      "O Reino Unido oferece uma mistura única de tradição monárquica, vanguarda cultural, paisagens escocesas deslumbrantes e cidades históricas.",
    gastronomy: "Peixe com batatas fritas, rosbife, pudim de Yorkshire, chá.",
    landmarks: [
      "Big Ben e Palácio de Westminster",
      "Stonehenge",
      "Torre de Londres",
      "Castelo de Edimburgo",
    ],
    overseas: ["Bermudas", "Ilhas Cayman", "Gibraltar"],
  },
  pt: {
    description:
      "Portugal encanta com as suas ruas coloridas, as praias banhadas pelo Atlântico e a excepcional hospitalidade do seu povo, ao som da melodia assustadora do Fado.",
    gastronomy: "Pastéis de nata, bacalhau, Francesinha, Vinho do Porto.",
    landmarks: [
      "Torre de Belém, Lisboa",
      "Ribeira, Porto",
      "Palácio da Pena, Sintra",
      "Praias algarvias",
    ],
    overseas: ["Madeira", "Açores"],
  },
  gr: {
    description:
      "Berço da civilização ocidental, a Grécia convida você a uma viagem mitológica, da Acrópole às sublimes águas cristalinas das ilhas Cíclades.",
    gastronomy: "Moussaka, souvlaki, salada grega, tzatziki.",
    landmarks: [
      "Acrópole de Atenas",
      "Santorini",
      "Meteora",
      "Palácio de Cnossos",
    ],
    overseas: ["Creta", "Rodes"],
  },
  nl: {
    description:
      "A Holanda é famosa pelas suas paisagens planas, canais labirínticos, campos de tulipas e moinhos de vento icónicos.",
    gastronomy: "Gouda, stroopwafel, arenque cru, poffertjes.",
    landmarks: [
      "Canais de Amsterdã",
      "Moinhos de Vento Kinderdijk",
      "Museu Van Gogh",
    ],
    overseas: ["Aruba", "Curaçau", "São Martinho"],
  },
  dk: {
    description:
      "A Dinamarca representa o conceito de 'Hygge': um país nórdico pacífico, pioneiro em design, cheio de ciclovias e palácios reais.",
    gastronomy: "Smørrebrød, frikadeller, Wienerbrød, cerveja Carlsberg.",
    landmarks: ["Nyhavn", "A Pequena Sereia", "Castelo de Kronborg"],
    overseas: ["Ilhas Faroé", "Groenlândia"],
  },
  mk: {
    description:
      "No coração dos Balcãs, a Macedónia do Norte deslumbra com o antigo e incrivelmente claro Lago Ohrid, a sua herança ortodoxa e os parques nacionais preservados.",
    gastronomy: "Tavče gravče (feijão cozido), ajvar, pastrmajlija.",
    landmarks: ["Lago Ohrid", "Igreja de São João em Kaneo", "Cânion Matka"],
  },
  es: {
    description:
      "Espanha fascina com o seu clima ensolarado, cultura vibrante, desde as sestas ao flamenco, praias magníficas e arquitectura histórica única, especialmente a sua herança mourisca.",
    gastronomy: "Tapas, paella, presunto ibérico, gaspacho, sangria.",
    landmarks: [
      "Sagrada Família, Barcelona",
      "Alhambra, Granada",
      "Palácio Real de Madri",
      "Praça de Espanha, Sevilha",
    ],
    overseas: ["Ilhas Canárias", "Ilhas Baleares", "Ceuta", "Melilha"],
  },
  sm: {
    description:
      "Situado no Monte Titano e completamente sem litoral pela Itália, San Marino reivindica o título de república e estado constitucional soberano mais antigo do mundo.",
    gastronomy: "Torta Tre Monti, piadina, feijão com torresmo.",
    landmarks: [
      "As Três Torres (Guaita, Cesta, Montale)",
      "Basílica de São Marino",
      "Praça da Liberdade",
    ],
  },
  rs: {
    description:
      "A Sérvia combina a vibrante vida noturna de Belgrado, no Danúbio, a dramática fortaleza de Petrovaradin e os soberbos mosteiros ortodoxos escondidos.",
    gastronomy: "Cevapi, pljeskavica, kajmak, rakija (conhaque de frutas).",
    landmarks: [
      "Fortaleza de Belgrado (Kalemegdan)",
      "Fortaleza de Golubac",
      "Templo de São Sava",
    ],
  },
  va: {
    description:
      "O Vaticano, o menor estado soberano do mundo, reside no coração de Roma, servindo como sede espiritual da Igreja Católica, abrigando prodigiosas obras-primas artísticas de Michelangelo.",
    gastronomy:
      "Nenhuma cozinha exclusiva; apresenta gastronomia tradicional romana.",
    landmarks: [
      "Basílica de São Pedro",
      "Capela Sistina",
      "Museus do Vaticano",
    ],
  },
};
